import { render, staticRenderFns } from "./STCalidad.vue?vue&type=template&id=0c353274&"
import script from "./STCalidad.vue?vue&type=script&lang=js&"
export * from "./STCalidad.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports